module.exports = __webpack_public_path__ + "static/img/s09.e22cf201.png";